import { Disclosure, DisclosureButton, DisclosurePanel, Tab, TabGroup, TabList, TabPanel, TabPanels, Transition } from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/16/solid";
import axios from "axios";
import moment from "moment";
import React, { Fragment, useState } from "react";
import Dropzone from "react-dropzone";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import add_img from "../../../assets/add_img_2.png";
import customer_name from "../../../assets/customer_name.svg";
import { TwButton, TwContainer, TwFormHelperText, TwInitialsAvatar, TwInputGroup, TwMainLayout, TwSelectGroup, TwSwitch } from "../../../components/tailwind";
import { handleUploadImageToS3 } from "../../../helpers";
import { useLocalStorage } from "../../../hooks";
import { useToast } from "../../../provider/ToastProvider";
import { dashboardState } from "../../../redux/reducers/dashboardReducer";
import { loadingState, setActionLoading, setSectionLoading } from "../../../redux/reducers/loadingReducer";
import { userState } from "../../../redux/reducers/userReducer";
import { getUrlForServices, getUrlForUsers } from "../../../utils/confighelpers";
import { OnBordingBaseLayout } from "../../../components/onboarding/OnBordingBaseLayout";
import MyResourceAvailableTimeForm from "./MyResourceAvailableTimeForm";


const openDayAndTimeObject = [
  {
    day: "monday",
    isOpen: true,
    openTime: [
      {
        startTime: "9:00 AM",
        endTime: "05:00 PM",
      },
    ],
  },
  {
    day: "tuesday",
    isOpen: true,
    openTime: [
      {
        startTime: "9:00 AM",
        endTime: "05:00 PM",
      },
    ],
  },
  {
    day: "wednesday",
    isOpen: true,
    openTime: [
      {
        startTime: "9:00 AM",
        endTime: "05:00 PM",
      },
    ],
  },
  {
    day: "thursday",
    isOpen: true,
    openTime: [
      {
        startTime: "9:00 AM",
        endTime: "05:00 PM",
      },
    ],
  },
  {
    day: "friday",
    isOpen: true,
    openTime: [
      {
        startTime: "9:00 AM",
        endTime: "05:00 PM",
      },
    ],
  },
  {
    day: "saturday",
    isOpen: true,
    openTime: [
      {
        startTime: "9:00 AM",
        endTime: "05:00 PM",
      },
    ],
  },
  {
    day: "sunday",
    isOpen: true,
    openTime: [
      {
        startTime: "9:00 AM",
        endTime: "05:00 PM",
      },
    ],
  },
];

const resource_type_list = {
  "host": "Host",
  // "employee": "Employee",
  // "venue": "Venue",
  // "court": "Playing field or court",
  // "table": "Table",
  "stylist": "Stylist",
  "masseuse": "Masseuse",
  "beautician": "Beautician",
  "therapist": "Therapist",
  "other": "Other",
};

const AddMyResource = ({ navigation }) => {

  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const defaultAvatarData = "https://bmcapp.s3.eu-west-1.amazonaws.com/assets/DefaultAvatar.png";
  const location = useLocation();
  const dispatch = useDispatch();
  const loadingReduxState = useSelector(loadingState);
  const dashboardReduxState = useSelector(dashboardState);
  const userReduxState = useSelector(userState);
  const [loadingDone, setLoadingDone] = React.useState(false);
  const [onBoardingState, setOnBoardingState] = React.useState(
    userReduxState && userReduxState.onBoardingData && Object.keys(userReduxState.onBoardingData).length > 0 ? userReduxState.onBoardingData : (location.state !== null ? location.state : null)
  );
  const [resourceDetails, setResourceDetails] = useState({
    fullName: location.state !== null && location.state?.from && location.state?.from == "registration" && onBoardingState !== null && onBoardingState?.fullName ? onBoardingState.fullName : "",
    resourceType: location.state !== null && location.state?.from && location.state?.from == "registration" ? "host" : "",
    profilePic: location.state !== null && location.state?.from && location.state?.from == "registration" ? onBoardingState?.avatar || onBoardingState?.profilePic || defaultAvatarData : defaultAvatarData,
    gender: location.state !== null && location.state?.from && location.state?.from == "registration" ? onBoardingState?.gender || "" : "",
    allowServiceAccess: [],
    validityStartDate: new Date(),
    validityEndDate: moment().add(30, 'days').format("YYYY-MM-DD"),
    scheduleWithoutValidity: false,
    openDayAndTime: openDayAndTimeObject
  });
  const [openDayAndTime, setOpenDayAndTime] = useState(openDayAndTimeObject);
  const [userToken] = useLocalStorage("userToken");

  const [edit, setEdit] = React.useState(false);
  const [editValues, setEditValues] = React.useState({});
  const [formErrors, setFormErrors] = React.useState({});
  const [tabValue, setTabValue] = React.useState('myprofile');
  // const [tabValue, setTabValue] = React.useState('servicesAccess');
  const [serviceList, setServiceList] = React.useState([]);
  const [allowServiceAccess, setAllowServiceAccess] = useState([]);
  const [categoryStates, setCategoryStates] = useState([]);

  const handleAddResource = async () => {

    const errors = {};
    // if (resourceDetails.profilePic === "") {
    //   errors.profilePic = "Please select profile photo.";
    // }
    if (resourceDetails.fullName === "") {
      errors.fullName = "Please enter resource name.";
    }
    if (resourceDetails.resourceType === "") {
      errors.resourceType = "Please select resource type.";
    }
    if (moment(resourceDetails?.validityEndDate).isBefore(moment(resourceDetails?.validityStartDate)) === true) {
      errors.validityEndDate = "Please select valid end date.";
    }
    openDayAndTime?.forEach((item) => {
      item?.openTime?.forEach((timings) => {
        if (!timings?.startTime || !timings?.endTime) {
          addErrorToast("Please select timings");
          return;
        }
      });
    });

    setFormErrors({ ...errors });
    if (Object.keys(errors).length > 0) {
      addErrorToast("Please fix errors below", { hideAfter: 3 });
      return;
    }
    const payloadBody = {
      // addedByUserId: userReduxState.userData?._id,
      ...resourceDetails?._id ? { resourceId: resourceDetails?._id || "" } : {},
      fullName: resourceDetails.fullName || "",
      resourceType: resourceDetails.resourceType || "",
      profilePic: resourceDetails.profilePic || defaultAvatarData,
      gender: resourceDetails.gender || "",
      allowServiceAccess: allowServiceAccess || [],
      scheduleWithoutValidity: resourceDetails.scheduleWithoutValidity || false,
      validityStartDate: moment(resourceDetails?.validityStartDate).format("YYYY-MM-DD"),
      validityEndDate: moment(resourceDetails?.validityEndDate).format("YYYY-MM-DD"),
      openDayAndTime: resourceDetails?.openDayAndTime,
      // busyDayAndTime: busyDayAndTime,
    };
    let config = {};
    if (edit) {
      config = {
        method: "put",
        url: `${getUrlForUsers()}updateProfile`,
        headers: {
          "x-access-token": userToken,
        },
        data: {
          ...(location.state?.from !== "list" ? { onBoardingStep: 3 } : {}),
          myResource: payloadBody
        },
      };
    } else {
      config = {
        method: "put",
        url: `${getUrlForUsers()}updateProfile`,
        headers: {
          "x-access-token": userToken,
        },
        data: {
          ...(location.state?.from !== "list" ? { onBoardingStep: 3 } : {}),
          myResource: payloadBody

        },
      };
    }

    dispatch(setSectionLoading(true));
    dispatch(setActionLoading(true));
    const request = await axios(config);
    dispatch(setSectionLoading(false));
    dispatch(setActionLoading(false));
    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        // addSuccessToast(request.data.message);
        if (location.state?.from === "list") {
          navigation("/myresource/");
        } else {
          navigation("/businessprofilesetup/done");
          // navigation("/businessprofilesetup/subscription");
        }
      } else {
        addErrorToast(request.data.message);
      }
    }
  };

  const renderLayout = (layoutType = "full", children) => {
    return layoutType == "full" ? (
      <TwMainLayout
        fullScreen={true}
        footerClass=""
        footerActions={[
          ...(location.state?.from === "list") ? [(<TwButton
            className="sm:min-w-32"
            variant="orange-outline"
            disabled={loadingReduxState.actionLoading}
            onClick={() => {
              navigation("/myresource/");
            }}
          >
            Cancel
          </TwButton>)] : [],
          (<TwButton
            className="sm:min-w-32"
            disabled={loadingReduxState.actionLoading}
            actionLoading={(loadingReduxState.actionLoading)}
            onClick={() => {
              handleAddResource();
            }}
          >
            {edit ? "Update" : "Save"}
          </TwButton>),
        ]}
      >
        <OnBordingBaseLayout
          title={"Add Your Business Hours"}
          logoutCallBack={() => { }}
        >
          {children}
        </OnBordingBaseLayout>
      </TwMainLayout>
    ) : (
      <TwMainLayout
        headTitle={`${edit ? "Update" : "Add New"}`}
        breadcrumbs={[
          { title: "My Team", onClick: () => { navigation("/myresource"); } },
          { title: `${edit ? "Update" : "Add New"}` },
        ]}
        headActions={[
          ...(location.state?.from === "list") ? [(<TwButton
            className="hidden sm:flex sm:min-w-32"
            variant="orange-outline"
            disabled={loadingReduxState.actionLoading}
            onClick={() => {
              navigation("/myresource/");
            }}
          >
            Cancel
          </TwButton>)] : [],
          (<TwButton
            className="hidden sm:flex sm:min-w-32"
            disabled={loadingReduxState.actionLoading}
            actionLoading={(loadingReduxState.actionLoading)}
            onClick={() => {
              handleAddResource();
            }}
          >
            {edit ? "Update" : "Save"}
          </TwButton>),
        ]}
        footerClass="sm:flex md:hidden"
        footerActions={[
          ...(location.state?.from === "list") ? [(<TwButton
            className="sm:flex md:hidden sm:min-w-32"
            variant="orange-outline"
            disabled={loadingReduxState.actionLoading}
            onClick={() => {
              navigation("/myresource/");
            }}
          >
            Cancel
          </TwButton>)] : [],
          (<TwButton
            className="sm:flex md:hidden sm:min-w-32"
            disabled={loadingReduxState.actionLoading}
            actionLoading={(loadingReduxState.actionLoading)}
            onClick={() => {
              handleAddResource();
            }}
          >
            {edit ? "Update" : "Save"}
          </TwButton>),
        ]}
        children={children} />

    );
  }

  const getUserInfo = async (id) => {
    dispatch(setSectionLoading(true));
    const config = {
      method: "get",
      url: `${getUrlForUsers()}getUserInfo?resourceId=${id}`,
      headers: {
        "x-access-token": userToken,
      },
    };
    const request = await axios(config);
    if (request.data.statusCode === 200) {
      let myResource = request.data.data?.myResource || [];
      let allowserviceaccess = [];
      myResource.map((d) => {
        if (d._id === id) {
          setResourceDetails({
            ...d,
            profilePic: d?.profilePic ? d?.profilePic : defaultAvatarData,
          });

          allowserviceaccess = (d?.allowServiceAccess || [])
          setAllowServiceAccess(d?.allowServiceAccess || [])
          // setDateRange({ startDate: request.data.data.validityStartDate, endDate: request.data.data.validityEndDate });
          setOpenDayAndTime(d?.openDayAndTime || openDayAndTimeObject)
          // setBusyDayAndTime(request.data.data?.busyDayAndTime || [])
          setEditValues((prevValues) => ({
            ...d
          }));
        }

        return d;
      });
      // setCategoryStates(serviceList.reduce((acc, category) => {
      //   acc[category._id] = {
      //     // isActive: false,
      //     isActive: false,
      //     services: category.services.reduce((servicesAcc, service) => {
      //       // servicesAcc[service._id] = false;
      //       servicesAcc[service._id] = allowserviceaccess.indexOf(service._id.toString()) >= 0;
      //       return servicesAcc;
      //     }, {}),
      //   };
      //   return acc;
      // }, {}))
      setLoadingDone(true)
    }
    dispatch(setSectionLoading(false));
  }

  const handleFormValueChange = (event) => {
    const { name, value } = event.target;
    setResourceDetails((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleChangePic = async (url) => {
    setResourceDetails((prevValues) => ({
      ...prevValues,
      profilePic: url,
    }));
  };

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const getListOfService = async () => {
    const manageServicesConfig = {
      method: "get",
      url: `${getUrlForServices()}list?getall=true&groupby=category`,
      headers: {
        "x-access-token": userToken,
      },
    };
    const manageServicesRequest = await axios(manageServicesConfig);
    if (manageServicesRequest.status === 200) {
      if (manageServicesRequest.data.data.length) {
        // if (false === (dashboardReduxState.resourceId !== undefined && dashboardReduxState.resourceId !== -1 && dashboardReduxState.resourceId !== "")) {
        //   let allowServiceAccess = []
        //   manageServicesRequest.data.data.services.map((d) => {
        //     allowServiceAccess.push(d._id.toString())
        //     return d
        //   })
        //   setAllowServiceAccess(allowServiceAccess)
        // }
        setServiceList(manageServicesRequest.data.data);

        setCategoryStates(manageServicesRequest.data.data.reduce((acc, category) => {
          acc[category._id] = {
            // isActive: false,
            isActive: (false === (dashboardReduxState.resourceId !== undefined && dashboardReduxState.resourceId !== -1 && dashboardReduxState.resourceId !== "")),
            services: category.services.reduce((servicesAcc, service) => {
              // servicesAcc[service._id] = false;
              servicesAcc[service._id] = (false === (dashboardReduxState.resourceId !== undefined && dashboardReduxState.resourceId !== -1 && dashboardReduxState.resourceId !== ""));
              return servicesAcc;
            }, {}),
          };
          return acc;
        }, {}))
      }
    }
  };

  const handleCategoryToggle = (categoryId) => {
    setCategoryStates((prevState) => {

      const newServicesState = Object.keys(prevState[categoryId].services).reduce(
        (acc, serviceId) => {
          acc[serviceId] = !prevState[categoryId].isActive; // Toggle all services
          return acc;
        },
        {}
      );

      return {
        ...prevState,
        [categoryId]: {
          isActive: !prevState[categoryId].isActive,
          services: newServicesState,
        },
      };
    });
  };

  const handleServiceToggle = (categoryId, serviceId) => {
    setCategoryStates((prevState) => ({
      ...prevState,
      [categoryId]: {
        ...prevState[categoryId],
        services: {
          ...prevState[categoryId].services,
          [serviceId]: !prevState[categoryId].services[serviceId],
        },
      },
    }));
  };

  React.useEffect(() => {
    (async () => {
      await getListOfService();
    })()
    if (dashboardReduxState.resourceId !== undefined && dashboardReduxState.resourceId !== -1 && dashboardReduxState.resourceId !== "") {
      setEdit(true)
      getUserInfo(dashboardReduxState.resourceId);
    } else {
      setLoadingDone(true)
      setResourceDetails((prevValues) => ({
        ...prevValues,
        openDayAndTime: openDayAndTimeObject
      }));
      setOpenDayAndTime(openDayAndTimeObject)
      setLoadingDone(false)
    }

  }, []);

  React.useEffect(() => {
    let allowserviceaccess = []
    Object.keys(categoryStates).map((c) => {
      Object.keys(categoryStates[c].services).map((s) => {
        if (categoryStates[c].services[s] === true) {
          allowserviceaccess.push(s)
        }
        return s
      })
      return c
    })
    setAllowServiceAccess(allowserviceaccess)
    /* setAllowServiceAccess((prevSelected) => {
      if (prevSelected.includes(service._id.toString())) {
        // Remove the ID if it's already in the list
        return prevSelected.filter((item) => item !== service._id.toString());
      } else {
        // Add the ID if it's not in the list
        return [...prevSelected, service._id.toString()];
      }
    }); */

  }, [categoryStates]);

  React.useEffect(() => {
    setTimeout(() => {
      if (editValues.allowServiceAccess !== undefined && editValues.allowServiceAccess.length > 0 && serviceList.length > 0) {
        // console.log("editValues.allowServiceAccess", editValues.allowServiceAccess);
        setCategoryStates(serviceList.reduce((acc, category) => {
          acc[category._id] = {
            // isActive: false,
            isActive: category.services.every(value => editValues.allowServiceAccess.includes(value._id)),
            services: category.services.reduce((servicesAcc, service) => {
              // servicesAcc[service._id] = false;
              servicesAcc[service._id] = editValues.allowServiceAccess.indexOf(service._id.toString()) >= 0;
              return servicesAcc;
            }, {}),
          };
          return acc;
        }, {}))
      }

    }, 1000);
  }, [loadingDone, editValues, serviceList]);

  return (renderLayout(location.state?.from === "list" ? "section" : "full",
    (<TwContainer className="py-0">
      <TabGroup>
        {location.state?.from === "list" && (<div className="border-b border-gray-200">
          <TabList className="-mb-px flex space-x-8">
            <Tab key="myprofile" className="whitespace-nowrap border-0 border-b-2 border-transparent py-6 text-sm font-medium text-gray-700 hover:border-gray-300 hover:text-gray-800 data-[selected]:border-brown-coffee data-[selected]:text-brown-coffee">
              Profile
            </Tab>
            <Tab key="servicesAccess" className="whitespace-nowrap border-0 border-b-2 border-transparent py-6 text-sm font-medium text-gray-700 hover:border-gray-300 hover:text-gray-800 data-[selected]:border-brown-coffee data-[selected]:text-brown-coffee">
              Services Access
            </Tab>
          </TabList>
        </div>)}
        <TabPanels as={Fragment}>
          <TabPanel key="myprofile">
            <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
              <div className="flex flex-col gap-5 sm:mx-auto sm:w-full sm:max-w-sm md:max-w-lg">
                <div className={"grid place-items-center mb-2"}>
                  <Dropzone
                    accept="image/png, image/jpeg"
                    noDrag={true}
                    onDrop={async (files) => {
                      const errors = {};
                      if (files[0]) {
                        dispatch(setActionLoading(true));
                        const file = await handleUploadImageToS3(files[0]);
                        if (file.result.ok) {
                          handleChangePic(file.location);
                        }
                        dispatch(setActionLoading(false));
                      } else {
                        // handleChangePic("https://bmcapp.s3.eu-west-1.amazonaws.com/assets/DefaultAvatar.png");
                        errors.photo = "Only PNG and JPG formats are allowed";
                      }
                      setFormErrors({ ...errors });
                    }}
                  >
                    {({ getRootProps, getInputProps }) => {
                      return (
                        <div
                          {...getRootProps({ className: "dropzone" })}
                          className={""}
                        >
                          <div className={"ml-4 w-32 h-28 md:w-44 md:h-40 rounded-full"}>
                            {resourceDetails.profilePic ? (<img
                              className={
                                "min-w-28 h-28 md:min-w-36 md:h-36 object-cover rounded-full"
                              }
                              src={resourceDetails.profilePic}
                              alt={""}
                            />) : (
                              <TwInitialsAvatar name={resourceDetails?.fullName || ""} className="size-28 md:size-36" textClassName="text-2xl" />
                            )}
                          </div>
                          <input {...getInputProps()} />
                          <div className={"-translate-y-10 translate-x-24 md:-translate-y-14 md:translate-x-32 size-10"}>
                            <div title={"Upload A New Image"}>
                              <span component={"span"}>
                                <img src={add_img} alt={"add icon"} />
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    }}
                  </Dropzone>
                  {formErrors["profilePic"] && (
                    <TwFormHelperText error={formErrors?.profilePic !== ""}>{formErrors["profilePic"]}</TwFormHelperText>
                  )}
                </div>
                <TwInputGroup
                  label={"Name"}
                  placeholder={"Provide the full name of the resource"}
                  name={"fullName"}
                  leftIcon={(<img className={""} src={customer_name} alt={""} />)}
                  value={resourceDetails.fullName}
                  onChange={handleFormValueChange}
                  errors={formErrors}
                />
                <TwSelectGroup label={"Role Type"}
                  placeholder={"Provide the full name of the resource"}
                  name={"resourceType"}
                  leftIcon={(<img className={""} src={customer_name} alt={""} />)}
                  options={Object.keys(resource_type_list).map((d, i) => ({ value: d, title: resource_type_list[d] }))}
                  value={resourceDetails.resourceType}
                  onChange={handleFormValueChange}
                  errors={formErrors} />
                <TwSelectGroup label={"Gender"}
                  placeholder={"Select Gender"}
                  name={"gender"}
                  leftIcon={(<img className={""} src={customer_name} alt={""} />)}
                  options={[
                    { value: "", title: "Select Gender" },
                    { value: "Male", title: "Male" },
                    { value: "Female", title: "Female" },
                    { value: "Other", title: "Other" },
                  ]}
                  value={resourceDetails.gender}
                  onChange={handleFormValueChange}
                  errors={formErrors} />
                <MyResourceAvailableTimeForm
                  profileDetails={resourceDetails}
                  setProfileDetails={setResourceDetails}
                  reloadData={loadingDone}
                  formErrors={formErrors}
                />
              </div>
            </div>
          </TabPanel>
          <TabPanel key="servicesAccess">
            <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
              <div className="flex flex-col gap-5 sm:mx-auto sm:w-full sm:max-w-sm md:max-w-lg">
                {serviceList.map((category, ci) => (
                  <Disclosure key={ci} defaultOpen className="border-2 border-bright-gray rounded-lg p-3 md:p-4">
                    {({ open }) => (
                      <div className="">
                        <DisclosureButton className="flex justify-between items-center w-full px-3 py-1 md:px-4 md:py-2 text-sm font-medium text-left rounded-lg">
                          <TwSwitch
                            name={"paymentAtVenue"}
                            checked={categoryStates[category._id]?.isActive}
                            onChange={() => {
                              handleCategoryToggle(category._id.toString())
                            }}
                            title={<p className="truncate text-base md:text-xl font-medium text-brown-coffee capitalize">{category.name}</p>}
                            onClick={(event) => event.stopPropagation()}
                          />
                          <ChevronUpIcon
                            className={`${open ? "transform rotate-180" : ""} w-5 h-5 text-gray-500`}
                          />
                        </DisclosureButton>
                        <Transition
                          show={open}
                          enter="transition-all duration-300 ease-out"
                          enterFrom="max-h-0 opacity-0"
                          enterTo="max-h-40 opacity-100"
                          leave="transition-all duration-200 ease-in"
                          leaveFrom="max-h-40 opacity-100"
                          leaveTo="max-h-0 opacity-0"
                        >
                          <DisclosurePanel className="overflow-hidden p-3 md:p-5">
                            <div className="flex flex-col gap-3 pl-8">
                              {category.services.map((service) => (
                                <TwSwitch
                                  key={service.id}
                                  name={"paymentAtVenue"}
                                  checked={allowServiceAccess.indexOf(service._id.toString()) >= 0}
                                  onChange={() => {
                                    handleServiceToggle(category._id, service._id)
                                  }}
                                  title={<span className="truncate text-base md:text-xl font-medium text-brown-coffee capitalize">{service.serviceName}</span>}
                                  onClick={(event) => event.stopPropagation()}
                                />
                              ))}
                            </div>
                          </DisclosurePanel>
                        </Transition>
                      </div>
                    )}
                  </Disclosure>
                ))}
              </div>
            </div>
          </TabPanel>
        </TabPanels>
      </TabGroup>
    </TwContainer>
    ))
  );
};

export default AddMyResource;
